let getters = {
    account_preferences: state => {
        return state.account.account_preferences || [];
    },
    all_samples: state => {
        return _.has(state, ['draft', 'sample_groups']) ? [].concat.apply([], state.draft.sample_groups.map(group => group.samples)) : [];
    },
    all_invalid_samples: (state, getters) => {
        return getters.all_samples.filter(sample => !sample.valid);
    },
    can_change_report_by_setting: (state, getters) => {
        return !getters.report_by_account_preference || !getters.report_by_account_preference.is_static
    },
    can_see_billing: state => {
        return state.user_can_see_billing;
    },
    invalid_sample_groups: state => {
        return _.has(state.draft, 'sample_groups') ? state.draft.sample_groups.filter(group => !group.valid) : [];
    },
    ready_to_submit: (state, getters) => {
        return !state.import_file && state.draft.valid && getters.invalid_sample_groups.length == 0 && getters.all_samples.length > 0 && getters.all_invalid_samples.length == 0;
    },
    receipt_url: state => {
        if (state.completed_order.account_nbr && state.completed_order.processed_orders) {
            let processed_orders = state.completed_order.processed_orders.filter(order => order.file_id);

            switch (processed_orders.length) {
                case 0:
                    break;

                case 1:
                    return '/documents/' + state.completed_order.account_nbr + '/' + processed_orders[0].file_id;
                    break;

                default:
                    let url = '/documents/' + state.completed_order.account_nbr + '?';
                    processed_orders.forEach(file => {
                        url += '&fileIds[]=' + file.file_id;
                    });
                    return url;
            }
        }

        return null;
    },
    report_by_account_preference: (state, getters) => {
        return getters.account_preferences.find(pref => pref.account_preference_key == "REPORTBY");
    },
    report_by_setting: (state, getters) => {
        return _.has(state.draft, 'details') ? state.draft.details.find(detail => parseInt(detail.field_key) === 1033) : null;
    },
    report_by_setting_value: (state, getters) => {
        return _.has(getters.report_by_setting, 'field_value') ? getters.report_by_setting.field_value : 'order';
    },
    report_comment_field: (state) => {
        return _.has(state.draft, 'details') ? state.draft.details.find(detail => parseInt(detail.field_key) === 1037) : null;
    },
    report_comment_field_value: (state, getters) => {
        return _.has(getters.report_comment_field, 'field_value') ? getters.report_comment_field.field_value : undefined;
    },
    sample_fields_by_sample_type_id: (state, getters) => sample_type_id =>  {
        const fields = getters.sample_type_fields(sample_type_id);
        return _.has(fields, ['sample', 'other']) ? fields.sample.other : [];
    },
    sample_group_by_index: state => index => {
        return _.has(state.draft, ['sample_groups', index]) ? state.draft.sample_groups[index] : null;
    },
    sample_by_indexes: (state, getters) => (group_index, sample_index) => {
        const sample_group = getters.sample_group_by_index(group_index);
        return _.has(sample_group, ['samples', sample_index]) ? sample_group.samples[sample_index] : null;
    },
    sample_type_by_id: state => sample_type_id => {
        const sample_type_group = state.sample_type_groups.find(group => group.sampleTypes.filter(sample_type => sample_type.sampleTypeID == sample_type_id).length > 0);
        return sample_type_group ? sample_type_group.sampleTypes.find(sample_type => sample_type.sampleTypeID == sample_type_id) : null;
    },
    sample_type_categories: state => {
        return state.sample_type_groups
            ? state.sample_type_groups.map(group => {
                return {
                    title: group.title,
                    categories: group.sampleTypes.map(sample_type => {
                        return sample_type.category
                    })
                    .filter((item, index, array) => {
                        return array.indexOf(item) === index
                    })
                }
            })
            : []

    },
    sample_type_fields: state => sample_type_id => {
        return _.has(state.sample_type_fields, sample_type_id) ? state.sample_type_fields[sample_type_id] : null;
    },
    sample_type_test_groups: state => sample_type_id => {
        return _.has(state.sample_type_test_groups, sample_type_id) ? state.sample_type_test_groups[sample_type_id] : null;
    },
    validate_field: state => (field, field_value) => {
        let errors = [];
        let invalid = [];

        if (field.required && !field_value) {
            errors.push(field.caption);
        }
        else {
            switch (field.format) {
                case '(yyyy-mm-dd)':
                    if (field_value && !/^\d{4}-\d{2}-\d{2}$/.test(field_value)) {
                        invalid.push(field.caption);
                    }
                    break;

                case '(hhmm)':
                    if (field_value && !/^([01]\d|2[0-3])([0-5]\d)$/.test(field_value)) {
                        invalid.push(field.caption);
                    }
                    break;

                case '(depth)':
                    if (field_value) {
                        let depths = field_value.split('-');

                        if (!/^\d+-\d+$/.test(field_value) || parseInt(depths[1]) < parseInt(depths[0])) {
                            invalid.push(field.caption + ' (start-end) ex: 0-6');
                        }
                    }
                    break;

                case '(email)':
                    if (field_value) {
                        const valid_email = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/i;
                        const emails = field_value.replace(/\s+/g,'').replace(/\,/g,';').split(';');
                        emails.forEach(email => {
                            if (!invalid.includes(field.caption) && !valid_email.test(String(email))) {
                                invalid.push(field.caption);
                            }
                        });
                    }

                    break;
            }
        }

        return { errors, invalid, valid: (invalid.length ==0 && errors.length == 0) };
    },
    visible_test_details: state => {
        const visible_test_details = state.test_details.data[state.test_details.visible_test_id];
        return visible_test_details ? visible_test_details : { caption: '', price: 0, details: [] };
    },
    test_blacklist: state => {
        return state.test_blacklist;
    }
};

export default getters;



// WEBPACK FOOTER //
// ./resources/assets/js/vuex/modules/analysis/getters.js